import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class PointService extends BaseService {
  getPoint(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/point').subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getDescription(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/point/what-is-ezpoint').subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getCategory(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/voucher/vouchers-categories').subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPointDetail(offset: number, limit: number, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`/point/detail?offset=${offset}&limit=${limit}`).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getVoucher(page: number, category: string, title: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`/voucher/get-vouchers?Page=${page}&Category=${category}&Title=${title}`).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  postRedeemVoucher(param: any, onSuccess: (data) => void, onError: (data) => void = null): any {
    const data = param;
    this.post('voucher/redeem-voucher', data).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getReward(offset: number, limit: number, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`voucherV2/my-vouchers?offset=${offset}&limit=${limit}`).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getRewardExpired(offset: number, limit: number, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`voucherV2/my-voucher-expiries?offset=${offset}&limit=${limit}`).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  postUseVoucher(param: any, onSuccess: (data) => void, onError: (data) => void = null): any {
    const data = param;
    this.post('voucherV2/use-voucher', data).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getRewardUsed(offset: number, limit: number, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`voucherV2/voucher-used?offset=${offset}&limit=${limit}`).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getStatusRedeem(voucherNumber: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`voucherV2/status-redeem?voucherGeneratedNo=${voucherNumber}`).subscribe(
      resp => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
